export default defineNuxtPlugin(() => {
  const { public: config } = useRuntimeConfig()

  const recaptchaScript = useScriptGoogleRecaptcha<GoogleRecaptchaApi>({
    siteKey: config.recaptchaSiteKey
  })

  const getToken = async (action: string): Promise<string> => {
    await recaptchaScript.load()

    const { grecaptcha } = window
    if (!grecaptcha) throw new Error('reCAPTCHA is not available')
    const api = grecaptcha.enterprise ?? grecaptcha

    await new Promise<void>((resolve) => api.ready(resolve))
    return api.execute(config.recaptchaSiteKey, { action })
  }

  const provided: {
    recaptcha?: {
      getToken: (action: string) => Promise<string>
    }
  } = {
    recaptcha: {
      getToken
    }
  }

  return {
    provide: provided
  }
})
